import React, { Fragment, useState } from "react";
import { Radio } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSendOrderToSliderMutation } from "redux/Logistic/SliderService";
import AppOutlineButton from "components/ui/AppOutlineButton";
import { UTILS } from "utils";
import { LoaderAction } from "redux/actions";
import { ifnullOrUndefined } from "utils/Utils";
import { errorHandler } from "api/api/errorHandler";

const CreateClaim = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);
  const [sendOrderToSlider] = useSendOrderToSliderMutation();
  const [insufficientBalanceError, setInsufficientBalanceError] = useState(null);
  const [vehicleType, setVehicleType] = useState("bike");

  const sendOrderToSliderFunc = async () => {
    try {
      if (!orderInfo?._id || !orderInfo?.storeId) return;
      // Additional check for paymentType and totalOrderPrice
      if (
        orderInfo?.paymentType === "CASH" &&
        orderInfo?.totalOrderPrice > 350
      ) {
        UTILS.errorNotification(
          t(
            "The Cash on Delivery (COD) limit is 350 AED. Please contact your Comera Account Manager or consider using a different delivery option."
          )
        );
        return;
      }
      dispatch(LoaderAction.setLoading(true));
      const result = await sendOrderToSlider({
        orderId: orderInfo._id,
        storeId: orderInfo?.storeId,
        vehicleType: vehicleType
      });
      if (result?.data?.success === 1) {
        UTILS.successNotification(t(result?.data?.message));
      } else {
        UTILS.errorNotification(t(result?.error?.data));
      }
      await props.fetchOrderDetailsByID();
    } catch (error) {
      const errorMessage = errorHandler(error?.error);
      if(errorMessage?.includes("Insufficient balance")) {
        setInsufficientBalanceError("Insufficient balance");
      }
      UTILS.handleErrorNotification(errorMessage);
    }
    new Promise((resolve) => setTimeout(resolve, 3000));
    dispatch(LoaderAction.setLoading(false));
  };

  // New method for the same logic, returns booleanorderInfo
  const isCashOrderAboveLimit = () => {
    return (
      orderInfo?.paymentType === "CASH" && orderInfo?.totalOrderPrice > 350
    );
  };

  const allowSendOrderToSlider = () => {
    if (
      ifnullOrUndefined(
        orderInfo?.logisticPartnerMetadata?.SLIDER?.createDeliveryResponse
          ?.order_number
      ) ||
      orderInfo?.logisticPartnerMetadata?.SLIDER?.deliveryStatus ===
        "CANCELED"
    ) {
      return true;
    }
    return false;
  };

  return (
    <Fragment key={props?.customKey}>
      <div className="w-full min-h-[100px] py-2">
        {insufficientBalanceError ? (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-2">
            {t(insufficientBalanceError)}
          </div>
        ) : isCashOrderAboveLimit() ? (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-2">
            {t(
              "The Cash on Delivery (COD) limit is 350 AED. Please contact your Comera Account Manager"
            )}{" "}
            <a
              href={`https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-green-700 hover:text-green-800"
              style={{ wordBreak: "break-all" }}
            >
              {process.env.REACT_APP_SUPPORT_MOBILE}
            </a>
            {t(" or consider using a different delivery option.")}
          </div>
        ) : allowSendOrderToSlider() ? (
          <div className="flex flex-col gap-3">
            <div className="flex flex-col items-center gap-2 sm:flex-row sm:justify-between sm:items-start">
              <div className="flex flex-col items-center gap-2 sm:items-start">
                <label className="text-sm text-gray-500">
                  {t("Select Vehicle Type")}
                </label>
                <Radio.Group
                  value={vehicleType}
                  onChange={(e) => setVehicleType(e?.target?.value)}
                >
                  <Radio name="vehicleType" value="car">
                    {t("Car")}
                  </Radio>
                  <Radio name="vehicleType" value="bike">
                    {t("Bike")}
                  </Radio>
                </Radio.Group>
              </div>
              <div className="flex justify-center items-center sm:pt-6">
                <AppOutlineButton
                  variant="secondary"
                  size="lg"
                  onClick={sendOrderToSliderFunc}
                >
                  {t("Send order to Slider")}
                </AppOutlineButton>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center text-center px-2 py-4">
            <span className="text-sm text-gray-500">
              {t(
                "Your order has been sent to Slider for delivery. Please check the ORDER DETAIL tab for Rider details"
              )}
            </span>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CreateClaim;
